import { Presentation } from '../types/presentation';

export const presentations: Presentation[] = [
  {
    title: 'Quantum error correction and the AdS/CFT correspondence(review)',
    presenter: 'Ikko Hamamura',
    authors: ['Ikko Hamamura'],
    workshopName: 'Summer School by Young Nuclear and Particle Physicist Group of Japan',
    workshopUrl: 'http://www.tuhep.phys.tohoku.ac.jp/~natsugaku2015/',
    place: 'Hotel Tatsuki',
    date: {
      from: '2015-8-17',
      to: '2015-8-22',
    },
    officialLang: 'ja',
    lang: 'ja',
    style: 'summerSchool',
  },
  {
    title: 'Relation between state-distinction power and disturbance in quantum measurements',
    presenter: 'Ikko Hamamura',
    authors: ['Ikko Hamamura', 'Takayuki Miyadera'],
    id: '16aAC-07',
    workshopName: 'JPS The 2015 Autumn Meeting',
    workshopUrl: 'http://www2.kansai-u.ac.jp/jps2015/',
    place: 'Kansai univ.',
    date: {
      from: '2015-9-16',
      to: '2015-9-19',
    },
    officialLang: 'ja',
    lang: 'ja',
    style: 'oral',
  },
  {
    title: 'Relation between state-distinction power and disturbance in quantum measurements',
    presenter: 'Ikko Hamamura',
    authors: ['Ikko Hamamura', 'Takayuki Miyadera'],
    workshopName: 'ImPACT Mirai Kaitaku Kenkyukai 2015',
    workshopUrl: 'http://www.jst.go.jp/impact/yamamoto/workshop/shikotsu.html',
    place: 'Kyukamura Shikotsuko',
    date: {
      from: '2015-10-13',
      to: '2015-10-18',
    },
    officialLang: 'ja',
    lang: 'ja',
    style: 'poster',
  },
  {
    title: 'Quantum non-demolition measurements from a perspective of quantum measuremant theory',
    presenter: 'Ikko Hamamura',
    authors: ['Ikko Hamamura'],
    workshopName: 'Quantum Information Kansai Student Chapter 19th',
    workshopUrl: 'http://yagura.scphys.kyoto-u.ac.jp/wakate/index.php?%E3%81%8A%E7%9F%A5%E3%82%89%E3%81%9B#o3ac5705',
    place: 'Osaka University',
    date: {
      from: '2015-11-28',
      to: '2015-11-28',
    },
    officialLang: 'ja',
    lang: 'ja',
    style: 'poster',
  },
  {
    title: 'Quantum Incompatibility and Information-Disturbance Tradeoff',
    presenter: 'Ikko Hamamura',
    authors: ['Ikko Hamamura'],
    workshopName: 'QMKEK',
    workshopUrl: 'http://www-conf.kek.jp/QMKEK/',
    place: 'Kobayashi Hall in High Energy Accelerator Research Organization',
    date: {
      from: '2016-2-17',
      to: '2016-2-18',
    },
    officialLang: 'ja',
    lang: 'ja',
    style: 'poster',
  },
  {
    title: 'Incompatibility in Quantum Theory',
    presenter: 'Ikko Hamamura',
    authors: ['Ikko Hamamura'],
    workshopName: '61th Condensed Matter Physics Summer School 2016',
    workshopUrl: 'http://cmpss.jp/forepast/ss2016/page/index.html',
    place: 'Hotel Charade Inn Shiga',
    date: {
      from: '2016-7-29',
      to: '2016-8-2',
    },
    officialLang: 'ja',
    lang: 'ja',
    style: 'summerSchool',
  },
  {
    title: 'Relation between state-distinction power and disturbance',
    presenter: 'Ikko Hamamura',
    authors: ['Ikko Hamamura'],
    workshopName: '61th Condensed Matter Physics Summer School 2016',
    workshopUrl: 'https://cmpss.jp/forepast/ss2016/page/index.html',
    place: 'Hotel Charade Inn Shiga',
    date: {
      from: '2016-7-29',
      to: '2016-8-2',
    },
    officialLang: 'ja',
    lang: 'ja',
    style: 'summerSchool',
  },
  {
    title: '物理量の測定と状態変化における両立不可能性',
    presenter: '濵村一航',
    authors: ['濵村一航'],
    workshopName: '第64回物性若手夏の学校 Condensed Matter Physics Summer School',
    workshopUrl: 'https://cmpss.jp/main.html',
    place: 'ぎふ長良川温泉ホテルパーク',
    date: {
      from: '2019-8-5',
      to: '2019-8-9',
    },
    officialLang: 'ja',
    lang: 'ja',
    style: 'summerSchool',
  },
  {
    title: '量子ボードゲーム「エンタングリオン」',
    presenter: '濵村一航',
    authors: ['濵村一航'],
    workshopName: '第64回物性若手夏の学校 Condensed Matter Physics Summer School',
    workshopUrl: 'https://cmpss.jp/main.html',
    place: 'ぎふ長良川温泉ホテルパーク',
    date: {
      from: '2019-8-5',
      to: '2019-8-9',
    },
    officialLang: 'ja',
    lang: 'ja',
    style: 'summerSchool',
  },
  {
    title: 'Incompatibility in general probability theories',
    presenter: 'Ikko Hamamura',
    authors: ['Ikko Hamamura', 'Takayuki Miyadera'],
    id: '16pKH-4',
    workshopName: 'JPS The 2016 Autumn Meeting',
    workshopUrl: 'http://h-jps.w3.kanazawa-u.ac.jp/jps2016f/jps2016f/homu.html',
    place: 'Kanazawa univ.',
    date: {
      from: '2016-9-13',
      to: '2016-9-16',
    },
    officialLang: 'ja',
    lang: 'ja',
    style: 'oral',
  },
  {
    title: 'Incompatibility of operation and relation between information and disturbance',
    presenter: 'Ikko Hamamura',
    authors: ['Ikko Hamamura'],
    workshopName: 'Mathematics in Quantum System Estimation',
    workshopUrl: 'http://bayes.sigmath.es.osaka-u.ac.jp/ftanaka/workshop/RIMS2016.html',
    place: 'Research Institute for Mathematical Sciences, Kyoto University',
    date: {
      from: '2016-10-26',
      to: '2016-10-28',
    },
    officialLang: 'ja',
    lang: 'ja',
    style: 'oral',
  },
  {
    title: 'On incompatible operation in quantum theory',
    presenter: 'Ikko Hamamura',
    authors: ['Ikko Hamamura'],
    workshopName: 'QUAntum Theory & Technology Un-Official Meeting',
    workshopUrl: 'http://www.sceng.kochi-tech.ac.jp/koban/quatuo/doku.php?id=%E7%AC%AC6%E5%9B%9Equatuo%E7%A0%94%E7%A9%B6%E4%BC%9A',
    place: 'Kochi University of Technology',
    date: {
      from: '2017-1-8',
      to: '2017-1-9',
    },
    officialLang: 'ja',
    lang: 'ja',
    style: 'poster',
  },
  {
    title: 'Relation between state-distinction power and disturbance in quantum measurements',
    presenter: 'Ikko Hamamura',
    authors: ['Ikko Hamamura'],
    workshopName: 'Workshop on Quantum Incompatibility',
    workshopUrl: 'http://miyaderatakayuki.wixsite.com/home/single-post/2017/01/12/Workshop-on-Quantum-Incompatibility',
    place: 'Kyoto University',
    date: {
      from: '2017-1-18',
      to: '2017-1-18',
    },
    officialLang: 'en',
    lang: 'en',
    style: 'oral',
  },
  {
    title: 'The structure of composite systems in quantum theory',
    presenter: 'Ikko Hamamura',
    authors: ['Ikko Hamamura'],
    workshopName: 'The 36th Quantum Information Technology Symposium (QIT36)',
    workshopUrl: 'https://staff.aist.go.jp/s-kawabata/qit/qit36/index_e.html',
    place: 'Ritesumeikan University, Suzaku Campus',
    date: {
      from: '2017-5-29',
      to: '2017-5-30',
    },
    officialLang: 'ja',
    lang: 'ja',
    style: 'oral',
  },
  {
    title: "Review of IBM's Cloud Quantum Computer",
    presenter: 'Ikko Hamamura',
    authors: ['Ikko Hamamura'],
    workshopName: 'Quantum Information Kansai Student Chapter 22th',
    workshopUrl: 'https://sites.google.com/site/qikansai/past/22meeting',
    place: 'Kyoto Univ.',
    date: {
      from: '2017-6-6',
      to: '2017-6-6',
    },
    officialLang: 'ja',
    lang: 'ja',
    style: 'poster',
  },
  {
    title: 'Entanglement of Effects',
    presenter: 'Ikko Hamamura',
    authors: ['Ikko Hamamura'],
    id: '24pA19-5',
    workshopName: 'JPS The 2017 Autumn Meeting',
    workshopUrl: 'http://w4.gakkai-web.net/jps_search/2017aue/data/html/program.html',
    place: 'Iwate univ.',
    date: {
      from: '2017-9-21',
      to: '2017-9-24',
    },
    officialLang: 'ja',
    lang: 'ja',
    style: 'oral',
  },
  {
    title: 'The structure of composite systems in quantum theory',
    presenter: 'Ikko Hamamura',
    authors: ['Ikko Hamamura'],
    workshopName: 'Okinawa School in Physics: Coherent Quantum Dynamics (CQD 2017)',
    workshopUrl: 'https://groups.oist.jp/ja/cqd/cqd-2017',
    place: 'OIST Seaside House',
    date: {
      from: '2017-9-26',
      to: '2017-10-5',
    },
    officialLang: 'en',
    lang: 'en',
    style: 'summerSchool',
  },
  {
    title: 'Separability Criterion for Quantum Effects',
    presenter: 'Ikko Hamamura',
    authors: ['Ikko Hamamura'],
    workshopName: '18th Asian Quantum Information Science Conference',
    workshopUrl: 'http://aqis-conf.org/2018/',
    place: 'Nagoya Univ.',
    date: {
      from: '2018-09-08',
      to: '2018-09-12',
    },
    officialLang: 'en',
    lang: 'en',
    style: 'poster',
  },
  {
    title: 'Separability Criterion for Quantum Effects',
    presenter: 'Ikko Hamamura',
    authors: ['Ikko Hamamura'],
    workshopName: 'The YQIS Conference and CoQuS Summer School 2018',
    workshopUrl: 'https://yqis-coqus18.univie.ac.at/',
    place: 'University of Vienna',
    date: {
      from: '2018-09-17',
      to: '2018-09-21',
    },
    officialLang: 'en',
    lang: 'en',
    style: 'poster',
  },
  {
    title: '量子コンピュータソフトウェアの現状と未来',
    presenter: '濵村一航',
    authors: ['濵村一航'],
    workshopName: '第8回 QUATUO 研究会',
    workshopUrl: 'http://www.sceng.kochi-tech.ac.jp/koban/quatuo/doku.php?id=%E7%AC%AC8%E5%9B%9Equatuo%E7%A0%94%E7%A9%B6%E4%BC%9A',
    place: 'Kochi University of Technology',
    date: {
      from: '2018-10-6',
      to: '2017-10-7',
    },
    officialLang: 'ja',
    lang: 'ja',
    style: 'poster',
  },
  {
    title: '情報因果律からCHSHモノガミー不等式を導出する',
    presenter: '濵村一航',
    authors: ['濵村一航'],
    workshopName: '第9回 QUATUO 研究会',
    workshopUrl: 'http://www.sceng.kochi-tech.ac.jp/koban/quatuo/doku.php?id=%E7%AC%AC9%E5%9B%9Equatuo%E7%A0%94%E7%A9%B6%E4%BC%9A',
    place: '崇城大学',
    date: {
      from: '2020-1-11',
      to: '2020-1-12',
    },
    officialLang: 'ja',
    lang: 'ja',
    style: 'poster',
  },
  {
    title: '量子ボードゲームEntanglion',
    presenter: '濵村一航',
    authors: ['濵村一航'],
    workshopName: '第25回 量子情報関西 Student Chapter',
    workshopUrl: 'https://sites.google.com/site/qikansai/past/25meeting',
    place: 'Osaka Univ.',
    date: {
      from: '2018-12-6',
      to: '2018-12-6',
    },
    officialLang: 'ja',
    lang: 'ja',
    style: 'poster',
  },
  {
    title: 'CHSH monogamy and Information Causality',
    presenter: 'Ikko Hamamura',
    authors: ['Ikko Hamamura', 'Takayuki Miyadera'],
    id: '14aK304-1',
    workshopName: '74th Annual Meeting, The Physical Society of Japan',
    workshopUrl: 'https://w4.gakkai-web.net/jps_search/2019spe/data/html/program.html',
    place: 'Kyushu univ.',
    date: {
      from: '2019-3-14',
      to: '2019-3-17',
    },
    officialLang: 'ja',
    lang: 'ja',
    style: 'oral',
  },
  {
    title: '量子コンピュータを用いた非文脈依存性の破れの検証',
    presenter: '濵村一航',
    authors: ['濵村一航'],
    id: '10pK12-8',
    workshopName: '日本物理学会2019年秋季大会',
    workshopUrl: 'https://w4.gakkai-web.net/jps_search/2019au/data/html/program01.html',
    place: '岐阜大学',
    date: {
      from: '2019-9-10',
      to: '2019-9-13',
    },
    officialLang: 'ja',
    lang: 'ja',
    style: 'oral',
  },
  {
    title: 'Relation between state-distinction power and disturbance in quantum measurements',
    presenter: 'Ikko Hamamura',
    authors: ['Ikko Hamamura'],
    place: 'University of Turku',
    date: {
      from: '2017-3-13',
      to: '2017-3-13',
    },
    officialLang: 'en',
    lang: 'en',
    style: 'seminar',
  },
  {
    title: '量子論の合成系の構造',
    presenter: '濵村一航',
    authors: ['濵村一航'],
    workshopName: '理論セミナー',
    workshopUrl: 'https://www.kek.jp/ja/Conference/20171026160751/',
    place: '高エネルギー加速器研究機構',
    date: {
      from: '2017-10-26',
      to: '2017-10-26',
    },
    officialLang: 'ja',
    lang: 'ja',
    style: 'seminar',
  },
  {
    title: '正規分布近似を用いた期待値の計算の高速化',
    presenter: '濵村一航',
    authors: ['濵村一航'],
    workshopName: '第7回 量子ソフトウェア研究発表会',
    workshopUrl: 'https://www.ipsj.or.jp/kenkyukai/event/qs7.html',
    place: '大阪大学 豊中キャンパス / オンライン',
    date: {
      from: '2022-10-27',
      to: '2022-10-28',
    },
    officialLang: 'ja',
    lang: 'ja',
    style: 'oral',
  },
  {
    title: 'エンタングルした測定を用いたVQEの効率化',
    presenter: '濵村一航',
    authors: ['濵村一航', '今道貴司'],
    workshopName: '第4回 量子ソフトウェア研究発表会',
    workshopUrl: 'https://www.ipsj.or.jp/kenkyukai/event/qs4.html',
    place: 'オンライン',
    date: {
      from: '2021-10-14',
      to: '2021-10-15',
    },
    officialLang: 'ja',
    lang: 'ja',
    style: 'oral',
  },
  {
    title: 'Scalable quantum circuits for Hamiltonian simulation of classical conservative systems',
    presenter: '佐藤勇気',
    authors: ['佐藤勇気', '近藤瑠歩', '濵村一航', '小野寺民也', '山本直樹'],
    workshopName: '第12回 量子ソフトウェア研究発表会 (SIGQS)',
    workshopUrl: 'https://sigs.ipsj.or.jp/qs/event/qs012/',
    place: '大阪大学 基礎工学国際棟 シグマホール',
    date: {
      from: '2024-06-28',
      to: '2024-06-28',
    },
    officialLang: 'ja',
    lang: 'ja',
    style: 'oral',
  },
  {
    title: '固有値問題のための量子アルゴリズム',
    presenter: '濱村一航',
    authors: ['濱村一航'],
    workshopName: '第33回 量子情報関西 Student Chapter',
    workshopUrl: 'https://sites.google.com/site/qikansai/past/%E7%AC%AC33%E5%9B%9E',
    place: '京都大学 吉田キャンパス',
    date: {
      from: '2024-07-05',
      to: '2024-07-05',
    },
    officialLang: 'ja',
    lang: 'ja',
    style: 'seminar',
  },
  {
    title: 'AI for Quantum Computing: Algorithms and Workflow',
    presenter: 'Ikko Hamamura',
    authors: ['Ikko Hamamura'],
    workshopName: 'The First RIKEN Quantum International Workshop on Frontiers of Quantum Computing Applications and Quantum-HPC Integration',
    workshopUrl: 'https://indico.riken.jp/event/4814/',
    place: 'RIKEN, Wako, Japan',
    date: {
      from: '2026-05-25',
      to: '2026-05-26',
    },
    officialLang: 'en',
    lang: 'en',
    style: 'oral',
  },
  {
    title: '量子・HPCハイブリッド連携環境構築に向けた試みとその普及',
    presenter: '濵村一航, 荒川隆',
    authors: ['濵村一航', '荒川隆', '住元真司', '山崎一哉', '古家真之介', '中島研吾'],
    workshopName: '第198回ハイパフォーマンスコンピューティング・第14回量子ソフトウェア合同研究発表会',
    workshopUrl: 'https://www.ipsj.or.jp/kenkyukai/event/hpc198qs14.html',
    place: '北海道大学 / オンライン',
    date: {
      from: '2025-03-17',
      to: '2025-03-19',
    },
    officialLang: 'ja',
    lang: 'ja',
    style: 'oral',
  },
  {
    title: 'ヘテロジニアスなスーパーコンピュータを用いた量子・HPC ハイブリッド連携環境の検討',
    presenter: '荒川隆',
    authors: ['荒川隆', '濱村一航', '今村俊幸', '住元真司', '山崎一哉', '胡曜', '古家真之介', '中島研吾'],
    workshopName: '第203回ハイパフォーマンスコンピューティング・第17回量子ソフトウェア合同研究発表会',
    workshopUrl: 'https://www.ipsj.or.jp/kenkyukai/event/hpc203qs17.html',
    place: '北海道大学',
    date: {
      from: '2026-03-16',
      to: '2026-03-18',
    },
    officialLang: 'ja',
    lang: 'ja',
    style: 'oral',
  },
  {
    title: 'A Model Context Protocol Server for Quantum Execution in Hybrid Quantum-HPC Environments',
    presenter: 'Masaki Shiraishi',
    authors: ['Masaki Shiraishi', 'Ikko Hamamura', 'Tatsuya Ishigaki', 'Tadashi Kadowaki'],
    workshopName: 'QC4C3 workshop at QCNC 2026',
    workshopUrl: 'https://qcnc2026.github.io/workshops/qc4c3.html',
    place: 'Kanazawa, Japan',
    date: {
      from: '2026-05-18',
      to: '2026-05-22',
    },
    officialLang: 'en',
    lang: 'en',
    style: 'oral',
  },
  {
    title: 'HPCとAIが拓く量子計算の未来',
    presenter: '濵村一航',
    presenterRole: 'Invited Speaker',
    authors: ['濵村一航'],
    workshopName: '一般社団法人量子フォーラム オープンセミナー「若手が語る量子時代の情報技術最前線」',
    workshopUrl: 'https://qforum.org/news/event/open2606',
    place: 'オンライン',
    date: {
      from: '2026-06-02',
      to: '2026-06-02',
    },
    officialLang: 'ja',
    lang: 'ja',
    style: 'invited',
  },
  {
    title: 'Harnessing the Generative Quantum Eigensolver for Next-Generation Materials Design',
    presenter: 'Ikko Hamamura',
    authors: ['Qi Gao', 'Ikko Hamamura'],
    workshopName: 'Q2B 2026 Tokyo',
    workshopUrl: 'https://q2b.qcware.com/conference/2026-tokyo',
    place: 'Grand Hyatt Tokyo, Japan',
    date: {
      from: '2026-06-04',
      to: '2026-06-05',
    },
    officialLang: 'en',
    lang: 'en',
    style: 'invited',
  },
  {
    title: 'Building the Classical–Quantum Stack: What Do We Need from Each Other?',
    presenter: 'Ikko Hamamura',
    presenterRole: 'Panelist',
    authors: [
      'Takefumi Miyoshi (Moderator)',
      'Ikko Hamamura',
      'Takafumi Miyanaga',
      'Mitsuhisa Sato',
      'Yasunari Suzuki',
    ],
    workshopName: 'IEEE COOL Chips 29',
    workshopUrl: 'https://www.coolchips.org/',
    place: 'Tokyo, Japan',
    date: {
      from: '2026-04-15',
      to: '2026-04-17',
    },
    officialLang: 'en',
    lang: 'en',
    style: 'invited',
  },
  {
    title: 'Quantum and HPC Integration Panel',
    presenter: 'Ikko Hamamura',
    presenterRole: 'Panelist',
    authors: ['Yuval Boger (Moderator)', 'Ikko Hamamura', 'Hanhee Paik', 'Sebastian Hassinger'],
    workshopName: 'Q2B 2025 Tokyo',
    workshopUrl: 'https://q2b.qcware.com/conference/2025-tokyo',
    place: 'Grand Hyatt Tokyo, Japan',
    date: {
      from: '2025-05-15',
      to: '2025-05-16',
    },
    officialLang: 'en',
    lang: 'en',
    style: 'invited',
  },
  {
    title: 'NVIDIA CUDA-Qが加速する量子コンピューティングの未来',
    presenter: '濵村一航',
    presenterRole: 'Invited Speaker',
    authors: ['濵村一航'],
    workshopName: '第5回 量子コンピューティング EXPO 秋 (NexTech Week 2024 秋)',
    workshopUrl: 'https://www.nextech-week.jp/hub/ja-jp/conference/program2024_autumn.html#qc',
    place: '幕張メッセ, Japan',
    date: {
      from: '2024-11-20',
      to: '2024-11-22',
    },
    officialLang: 'ja',
    lang: 'ja',
    style: 'invited',
  },
  {
    title: 'AI for Science: What should we do?',
    presenter: 'Ikko Hamamura',
    presenterRole: 'Panelist',
    authors: [
      'Kengo Nakajima (Moderator)',
      'Sunita Chandrasekaran',
      'Estela Suarez',
      'Ikko Hamamura',
      'Mohamed Wahib',
      'Rio Yokota',
    ],
    workshopName: 'IEEE Cluster 2024',
    workshopUrl: 'https://clustercomp.org/2024/',
    place: 'Kobe International Conference Center, Kobe, Japan',
    date: {
      from: '2024-09-24',
      to: '2024-09-27',
    },
    officialLang: 'en',
    lang: 'en',
    style: 'invited',
  },
  {
    title: 'はじめての量子コンピューター',
    presenter: '濵村一航',
    authors: ['濵村一航'],
    workshopName: 'PyCon JP 2022',
    workshopUrl: 'https://2022.pycon.jp/',
    place: 'TOC Ariake, Tokyo, Japan / Online',
    date: {
      from: '2022-10-15',
      to: '2022-10-15',
    },
    officialLang: 'ja',
    lang: 'ja',
    style: 'oral',
  },
  {
    title: 'CUDA-Q入門、発展的な利用例とハンズオン',
    presenter: '濵村一航',
    presenterRole: 'Instructor',
    authors: ['濵村一航'],
    workshopName: 'CUDA-Qハンズオン講習会',
    workshopUrl: 'https://www.icts.nagoya-u.ac.jp/ja/sc/news/event/',
    place: '名古屋大学 情報基盤センター / オンライン',
    date: {
      from: '2025-05-12',
      to: '2025-05-12',
    },
    officialLang: 'ja',
    lang: 'ja',
    style: 'handsOn',
  },
  {
    title: 'Introduction to NVIDIA Quantum & Getting Started with CUDA-Q',
    presenter: '濵村一航',
    presenterRole: 'Instructor',
    authors: ['濵村一航'],
    workshopName: '第二回量子・古典ハイブリッドコンピューティングハンズオンセミナー (産総研 G-QuAT)',
    workshopUrl: 'https://www.aist.go.jp/',
    place: '産業技術総合研究所 (G-QuAT), Tokyo / オンライン',
    date: {
      from: '2024-09-09',
      to: '2024-09-09',
    },
    officialLang: 'ja',
    lang: 'ja',
    style: 'handsOn',
  },
  {
    title: 'AIが生成する量子プログラムとその実行',
    presenter: '濵村一航',
    presenterRole: 'Invited Speaker',
    authors: ['濵村一航'],
    workshopName: 'スーパーコンピュータ「不老・弐」へ向けたユーザ集会～AI for Scienceを支援するAI/エージェントスパコン稼働に向けて～',
    workshopUrl: 'https://icts.nagoya-u.ac.jp/ja/sc/news/event/2026-09-08-kickoffparty.html',
    place: '名古屋大学 情報基盤センター / オンライン',
    date: {
      from: '2026-09-08',
      to: '2026-09-08',
    },
    officialLang: 'ja',
    lang: 'ja',
    style: 'invited',
  },
  {
    title: 'スパコン「不老・弐」を用いた新しい研究展開',
    presenter: '濵村一航',
    presenterRole: 'Panelist',
    authors: [
      '片桐孝洋 (Moderator)',
      '平井浩一',
      '濵村一航',
      '吉田慶次',
      '西口浩司',
      '坂倉耕太',
      '林俊一郎',
    ],
    workshopName: 'スーパーコンピュータ「不老・弐」へ向けたユーザ集会～AI for Scienceを支援するAI/エージェントスパコン稼働に向けて～',
    workshopUrl: 'https://icts.nagoya-u.ac.jp/ja/sc/news/event/2026-09-08-kickoffparty.html',
    place: '名古屋大学 情報基盤センター / オンライン',
    date: {
      from: '2026-09-08',
      to: '2026-09-08',
    },
    officialLang: 'ja',
    lang: 'ja',
    style: 'invited',
  },
  {
    title: 'CUDA-Qが拓く量子古典ハイブリッド計算の未来',
    presenter: '濵村一航',
    presenterRole: 'Invited Speaker',
    authors: ['濵村一航'],
    workshopName: '第5回 スーパーコンピュータ「不老」 ユーザ会',
    workshopUrl: 'https://icts.nagoya-u.ac.jp/ja/sc/news/event/2024-10-02-user2.html',
    place: '名古屋大学 情報基盤センター / オンライン',
    date: {
      from: '2024-10-02',
      to: '2024-10-02',
    },
    officialLang: 'ja',
    lang: 'ja',
    style: 'invited',
  },
];
